/**
 * Estado de revelado de las barras misteriosas de UN vertido (lógica pura).
 *
 * Cada barra "?" morada revela su valor (2..7) la primera vez que la toca
 * CUALQUIER bola del vertido; a partir de ahí queda fija para el resto de
 * las bolas de ese mismo vertido. Este objeto se crea nuevo en cada
 * `PlinkoView.start(...)` y se descarta al terminar.
 */

import type { Rng } from '../../core/rng';
import { MYSTERY_MAX, MYSTERY_MIN } from './constants';

/** Identificador estable de una barra dentro de un `BoardDef`: "fila-columna". */
export function barId(rowIndex: number, barIndex: number): string {
  return `${rowIndex}-${barIndex}`;
}

export class MysteryRevealState {
  private revealed = new Map<string, number>();

  /** Fija de antemano el valor de una barra (p.ej. por la carta "revela misteriosas"). */
  seed(id: string, value: number): void {
    this.revealed.set(id, value);
  }

  /**
   * Devuelve el valor revelado de la barra `id`. Si es el primer toque, lo
   * sortea en [MYSTERY_MIN, MYSTERY_MAX] y lo fija para el resto del
   * vertido (llamadas posteriores con el mismo id devuelven siempre lo
   * mismo, sin volver a consumir el `rng`).
   */
  reveal(id: string, rng: Rng): number {
    const existing = this.revealed.get(id);
    if (existing !== undefined) return existing;
    const value = rng.int(MYSTERY_MIN, MYSTERY_MAX);
    this.revealed.set(id, value);
    return value;
  }

  /** Consulta sin efecto secundario: `undefined` si aún no se reveló. */
  get(id: string): number | undefined {
    return this.revealed.get(id);
  }

  isRevealed(id: string): boolean {
    return this.revealed.has(id);
  }
}
